import { gql } from "@apollo/client";
import { BUSINESS_FIELDS_FRAGMENT } from "../queries";

export const POST_BUSINESS_BASIC = gql`
  mutation($input: BusinessInput) {
    createBusiness(input: $input) {
    ${BUSINESS_FIELDS_FRAGMENT}
    }
  }
`;


export const UPDATE_BUSINESS_BASIC = gql`
  mutation UpdateBusiness($input: BusinessInput) {
    updateBusiness(input: $input) {
      ${BUSINESS_FIELDS_FRAGMENT}
    }
  }
`;

export const SEND_EMAIL_MUTATION = gql`
  mutation mailer($bookingId: ID, $from_email: String, $to: String!, $subject: String!, $text: String!, $html: String) {
    sendEmailMutation(bookingId: $bookingId, from_email: $from_email, to: $to, subject: $subject, text: $text, html: $html)
  }
`;
export const SEND_CANCELLATION_NOTICE = gql`
  mutation sendCancellationNotice($input: CancellationNoticeInput!) {
    sendCancellationNotice(input: $input) {
      ok
      id
      message
    }
  }
`;
export const CANCEL_INQUIRY = gql`
  mutation cancelInquiry($input: CancelInquiryInput!) {
    cancelInquiry(input: $input) {
      ok
      id
      message
    }
  }
`;
export const CANCEL_INQUIRY_AND_NOTIFY = gql`
  mutation cancelInquiryAndNotify($input: CancelInquiryAndNotifyInput!) {
    cancelInquiryAndNotify(input: $input) {
      ok
      id
      message
    }
  }
`;

export const UPLOAD_IMAGE = gql`
  mutation uploadImage($id: int, $imageUrl: string){
    uploadImage(id: $id, imageUrl: $imageUrl){
    image
    }
}
`
export const MAP_USER_TO_BUSINESS = gql`
  mutation MapUserToBusiness($input: MapUserToBusinessInput) {
    mapUserToBusiness(input: $input) {
      success
      message
      token
      business { id name } 
    }
  }
`;